// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 918) return "models-detail.1.3.6.bundle.css";
	// return url for filenames based on template
	return "" + (chunkId === 483 ? "owl-carousel" : chunkId) + "." + {"483":"dbd95f101c6b3c48bbd7","942":"43f54cecfc957d21fc44","998":"ae6d67cabb8e690d14e3"}[chunkId] + ".css";
};